module.exports = __webpack_public_path__ + "static/media/IP-footer.97bdf61f.png";